import { useSelector } from "react-redux";

import { getScaleSegments, getSelectedSegment, getStyle } from "../../../ducks/style/selectors";
import { castScaleToResolution } from "../../../evergis/core/scale";
import { getSegmentIndex } from "../../../utils/style";
import { useDefaultScaleRange } from "../../../hooks/style/useDefaultScaleRange";
import { Style } from "../../../ducks/style/style";
import { StyleProxy } from "../../../evergis/core/classification/StyleProxy";

export function useCurrentLayerStyle(): Style {
  return useSelector(getStyle);
}

export function useCurrentLayerStyleProxy(): StyleProxy | null {
  const scaleSegments = useSelector(getScaleSegments);
  const selectedSegment = useSelector(getSelectedSegment);
  const segmentIndex = getSegmentIndex({ scaleSegments, selectedSegment });
  const resolution = castScaleToResolution([selectedSegment, scaleSegments?.[segmentIndex + 1]]);
  const style = useCurrentLayerStyle();
  const defaultScaleRange = useDefaultScaleRange();

  return style ? new StyleProxy(style, defaultScaleRange, resolution[0]) : null;
}
